import { Author } from '@natu/ui/Author';
import { ConditionalLink } from '@natu/ui/ConditionalLink';
import { getSlugWithDash } from '@natu/utils/getSlugWithDash';

import { getAssetFromStoryblok, StoryblokAsset } from '../../../../../../utils';
import { getDateAndReadTime } from '../../../../utils/getDateAndReadTime';

interface ArticleAuthorProps {
  author?: {
    name?: string;
    full_slug?: string;
    content?: {
      image?: StoryblokAsset;
    };
  };
  date?: string;
  readTime?: string;
}

export const ArticleAuthor = ({ author, date, readTime }: ArticleAuthorProps) => {
  if (!author) return null;

  const { name, full_slug, content } = author;

  const imageData = getAssetFromStoryblok(content?.image as StoryblokAsset | undefined, {
    type: 'image',
  });

  return (
    <ConditionalLink href={getSlugWithDash(full_slug)}>
      <Author
        name={name || ''}
        role={getDateAndReadTime(date, readTime)}
        image={imageData}
        variant="blog"
      />
    </ConditionalLink>
  );
};
